import { Injectable, InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';

export const enum Feature {
  salesTeam = 'sales-team',
  pipeline = 'ssc-pipeline',
}

export interface AccessServiceInterface {
  hasAccessToFeature(feature: Feature | string): Observable<boolean>;
}

export const AccessServiceInterfaceToken: InjectionToken<AccessServiceInterface> =
  new InjectionToken<AccessServiceInterface>('AccessServiceInterface');

@Injectable()
export class AccessServiceInterfaceStub implements AccessServiceInterface {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  hasAccessToFeature(feature: Feature | string): Observable<boolean> {
    return of(true);
  }
}
